/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-item-measure.reducer';

export const LabItemMeasureDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labItemMeasureEntity = useAppSelector(state => state.labItemMeasure.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labItemMeasureDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labItemMeasure.detail.title">LabItemMeasure</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.id">Id</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.id}</dd>
          <dt>
            <span id="ageMin">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.ageMin">Age Min</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.ageMin}</dd>
          <dt>
            <span id="ageMax">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.ageMax">Age Max</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.ageMax}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.gender}</dd>
          <dt>
            <span id="weightMin">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.weightMin">Weight Min</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.weightMin}</dd>
          <dt>
            <span id="weightMax">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.weightMax">Weight Max</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.weightMax}</dd>
          <dt>
            <span id="displayPrecision">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.displayPrecision">Display Precision</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.displayPrecision ? 'true' : 'false'}</dd>
          <dt>
            <span id="hiAbsolute">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiAbsolute">Hi Absolute</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.hiAbsolute}</dd>
          <dt>
            <span id="hiCritical">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiCritical">Hi Critical</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.hiCritical}</dd>
          <dt>
            <span id="hiNormal">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.hiNormal">Hi Normal</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.hiNormal}</dd>
          <dt>
            <span id="lowAbsolute">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowAbsolute">Low Absolute</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.lowAbsolute}</dd>
          <dt>
            <span id="lowCritical">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowCritical">Low Critical</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.lowCritical}</dd>
          <dt>
            <span id="lowNormal">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.lowNormal">Low Normal</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.lowNormal}</dd>
          <dt>
            <span id="units">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.units">Units</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.units}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.active">Active</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {labItemMeasureEntity.created ? <TextFormat value={labItemMeasureEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labItemMeasure.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labItemMeasureEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labItemMeasure.testItem">Test Item</Translate>
          </dt>
          <dd>{labItemMeasureEntity.testItem ? labItemMeasureEntity.testItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labItemMeasure.diagLab">Diag Lab</Translate>
          </dt>
          <dd>{labItemMeasureEntity.diagLab ? labItemMeasureEntity.diagLab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-item-measure" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-item-measure/${labItemMeasureEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabItemMeasureDetail;
